import Layout from '@/apps/layout/components'
import PrivacyPolicy from '@/apps/PrivacyPolicy'
import React from 'react'

const PrivacyPolicyPage = (): React.ReactElement => {
  return (
    <Layout>
      <PrivacyPolicy />
    </Layout>
  )
}

export default PrivacyPolicyPage
